import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { IFabricationOrderDelivery } from '../../../../store/ducks/fabrication-orders/types';
import NFEColumn from './NFEColumn';
import { Container, SubTitle } from './styles';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import GoBackButtonFacelift from '../../../../components/GoBackButton/Facelift';
import { Title } from '@gerdau/hefesto';
import {
  TitleContainer,
  TableContainer
} from '../FabricationOrderDetails/styles';
import Table from '../../../../components/Table';
import { TFabricationView } from '..';

interface FabricationOrderDeliveriesTableDataSource {
  key: number;
  delivery: IFabricationOrderDelivery;
  deliveryId: number;
  constructionStep: string;
  description: string;
  scheduledDate: string;
  totalWeight: number;
}

interface IDeliveriesTableProps {
  contractNumber: string;
  fabricationOrderId: number;
  customerId: string;
  deliveries: IFabricationOrderDelivery[];
  setActiveView: (activeView: TFabricationView) => void;
}

const DeliveriesTable: React.FC<IDeliveriesTableProps> = ({
  contractNumber,
  fabricationOrderId,
  customerId,
  deliveries,
  setActiveView
}) => {
  const dispatch = useDispatch();

  const customerViewType = useSelector(
    (state: ApplicationState) => state.user.searchCustomerType
  );
  const [fabricationOrderDeliveriesData, setFabricationOrderDeliveriesData] =
    useState<FabricationOrderDeliveriesTableDataSource[]>([]);

  useEffect(() => {
    const orderItensData: FabricationOrderDeliveriesTableDataSource[] =
      deliveries.map((delivery, idx) => {
        return {
          key: idx,
          delivery,
          deliveryId: delivery.deliveryId,
          constructionStep: delivery.constructionStep || ' - ',
          description: delivery.description,
          scheduledDate: delivery.scheduledDate,
          totalWeight: delivery.totalWeight
        };
      });

    setFabricationOrderDeliveriesData(orderItensData);
  }, [`${deliveries}`]);

  useEffect(() => {
    dispatch(
      sendTagging({
        event: 'page_view',
        screenName: 'LG:MeusPedidos:CorteDobra:DetalhesDasEntregas',
        page: document.location.pathname
      })
    );
  }, []);

  const getColumns = () => {
    return [
      {
        title: 'ID Entrega',
        dataIndex: 'deliveryId',
        sorter: (
          a: FabricationOrderDeliveriesTableDataSource,
          b: FabricationOrderDeliveriesTableDataSource
        ) => a.deliveryId - b.deliveryId,
        render: (deliveryId: string) => <>{deliveryId}</>
      },
      {
        title: 'Etapa da obra',
        dataIndex: 'constructionStep',
        sorter: (
          a: FabricationOrderDeliveriesTableDataSource,
          b: FabricationOrderDeliveriesTableDataSource
        ) => a.constructionStep.localeCompare(b.constructionStep),
        render: (constructionStep: string) => <>{constructionStep || ' - '}</>
      },
      {
        title: 'Descrição da entrega',
        dataIndex: 'description',
        sorter: (
          a: FabricationOrderDeliveriesTableDataSource,
          b: FabricationOrderDeliveriesTableDataSource
        ) => a.description.localeCompare(b.description),
        render: (description: string) => <>{description}</>
      },
      {
        title: 'Data de entrega',
        dataIndex: 'scheduledDate',
        sorter: (
          a: FabricationOrderDeliveriesTableDataSource,
          b: FabricationOrderDeliveriesTableDataSource
        ) =>
          moment(a.scheduledDate, 'YYYY-MM-DD').toDate().getTime() -
          moment(b.scheduledDate, 'YYYY-MM-DD').toDate().getTime(),
        render: (scheduledDate: string) => (
          <>
            {scheduledDate
              ? moment(scheduledDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
              : '-'}
          </>
        )
      },
      {
        title: 'Peso total',
        dataIndex: 'totalWeight',
        sorter: (
          a: FabricationOrderDeliveriesTableDataSource,
          b: FabricationOrderDeliveriesTableDataSource
        ) => a.totalWeight - b.totalWeight,
        render: (totalWeight: number) => (
          <>
            {totalWeight ? (
              <>{totalWeight.toFixed(2).toString().replace('.', ',')} T</>
            ) : (
              <>-</>
            )}
          </>
        )
      },
      {
        title: '',
        dataIndex: 'delivery',
        align: 'center' as const,
        width: 4,
        render: (item: IFabricationOrderDelivery) => (
          <>
            <NFEColumn
              item={item}
              contractNumber={contractNumber}
              fabricationOrderId={fabricationOrderId}
              customerId={customerId}
              customerViewType={customerViewType}
            />
          </>
        )
      }
    ];
  };

  return (
    <>
      <Container>
        <TitleContainer>
          <GoBackButtonFacelift
            title="Voltar"
            onClick={() =>
              setActiveView({ view: 'fabricationTable', data: undefined })
            }
          />
          <Title level={1}>{`Detalhes das entregas`}</Title>
          <SubTitle>
            Veja os detalhes das entregas relacionadas ao pedido selecionado.
          </SubTitle>
        </TitleContainer>
      </Container>
      <TableContainer>
        <Table
          columns={getColumns()}
          data={fabricationOrderDeliveriesData}
          hasPagination
        />
      </TableContainer>
    </>
  );
};

export default DeliveriesTable;
